export const ENTERPRISE_CONTRACT_STATUS = {
  DRAFT: 'DRAFT',
  ACTIVE: 'ACTIVE',
  PAUSED: 'PAUSED',
  FINISHED: 'FINISHED',
  CANCELLED: 'CANCELLED',
} as const;

export const RECORD_FIELD_TYPE = {
  TEXT: 'text',
  TEXTAREA: 'textarea',
  DATE: 'date',
  NUMBER: 'number',
  BOOLEAN: 'boolean',
  SELECT: 'select',
} as const;

export type RecordFieldType = (typeof RECORD_FIELD_TYPE)[keyof typeof RECORD_FIELD_TYPE];

export const ENTERPRISE_ACTIVITY_TYPE = {
  PATIENT_ADDED: 'PATIENT_ADDED',
  APPOINTMENT_BOOKED: 'APPOINTMENT_BOOKED',
  APPOINTMENT_SESSION_STARTED: 'APPOINTMENT_SESSION_STARTED',
  ADMIN_ADDED: 'ADMIN_ADDED',
  USER_LOGGED_IN: 'USER_LOGGED_IN',
} as const;
